import { dittoCaseStudy } from './dittoCaseStudy';
import { oraclePaymentsCaseStudy } from './oraclePaymentsCaseStudy';
import { qrPayCaseStudy } from './qrPayCaseStudy';
import { kitCaseStudy } from './kitCaseStudy';

export const caseStudies = {
  'oracle-payments': oraclePaymentsCaseStudy,
  'qr-pay': qrPayCaseStudy,
  ditto: dittoCaseStudy,
  kit: kitCaseStudy,
};
